<template>
  <div>
    <div class="slots" v-if="alreadyReserved">
      <div class="reservation-title">
        <span>La tua prenotazione del {{dateStr}}</span>
      </div>
    </div>
    <div class="edit-card">
      <div>
        <i class="rds-icon rds-icon-orologio"></i>
      </div>
      <div class="label grow" v-if="!isAlreadyReservedSet">Seleziona orario</div>
      <div class="label grow" v-if="isAlreadyReservedSet">Orario</div>
      <div class="price select-container">
        <select v-bind:disabled="isAlreadyReservedSet" v-model="reservation.selectedTimeSlot">
          <option
            v-bind:key="i"
            v-for="(timeSlot, i) in timeSlots"
            v-bind:value="timeSlot"
          >{{ timeSlot }}</option>
        </select>
        <span>{{reservation.selectedTimeSlot}}</span>
      </div>
    </div>
    <div
      v-bind:class="{selected: isSubtypeSelected(subtype)}"
      class="edit-card"
      v-on:tap="selectSubtype(subtype)"
      v-for="subtype in reservationType.subtypes"
      v-bind:key="subtype.id"
    >
      <div class="grow">{{subtype.label}}</div>
      <div class="price">{{subtype.price}}</div>
    </div>
    <div
      v-if="!isAlreadyReservedSet"
      v-on:tap="saveReservation()"
      class="edit-card edit-card-button"
    >
      <div>Prenota</div>
    </div>
    <div
      v-if="isAlreadyReservedSet"
      v-on:tap="deleteReservation()"
      class="edit-card edit-card-button"
    >
      <div>Cancella Prenotazione</div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'bike-reservation-editor',
  props: ['reservationType', 'selectedDay', 'alreadyReserved'],
  data() {
    return {
      timeSlots: this.reservationType.timeSlots,
      reservation: {
        type: 'bike',
        subtype: null,
        selectedTimeSlot: '14.00'
      }
    };
  },
  computed: {
    isAlreadyReservedSet() {
      if (!!this.alreadyReserved) {
        this.reservation.selectedTimeSlot = this.alreadyReservedTimeSlot; // eslint-disable-line vue/no-side-effects-in-computed-properties
      }
      return !!this.alreadyReserved;
    },
    alreadyReservedTimeSlot() {
      const resDate = new Date(this.alreadyReserved.date);
      const timeSlot = resDate
        .toLocaleString('it-it', {
          hour: '2-digit',
          minute: '2-digit'
        })
        .split(':')
        .join('.');
      return timeSlot;
    },
    dateStr() {
      return new Date(this.alreadyReserved.date)
        .toLocaleString('it-it', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric'
        }).replace(/\//g, '.');
    }
  },
  methods: {
    selectSubtype(subtype) {
      this.reservation.subtype = subtype;
    },
    isSubtypeSelected(subtype) {
      return this.reservation.subtype === subtype;
    },
    saveReservation() {
      let date = new Date(this.selectedDay);
      const splittedTime = this.reservation.selectedTimeSlot.split('.');
      date.setHours(splittedTime[0]);
      date.setMinutes(splittedTime[1]);
      const reservation = {
        date: date,
        subtype: this.reservation.subtype
      };
      this.$emit('reserve', reservation);
    },
    deleteReservation() {
      this.$emit('deleteReservation', this.alreadyReserved);
    }
  }
};
</script>
<style lang="scss" scoped>
.rds-icon-orologio {
  font-size: 1.35em;
}
.label {
  color: #7a7f85;
}
.price {
  color: #607d8b;
  background-color: #f4f4f4;
  padding: 13px 33px;
  border: #f6f6f6 solid 1px;
  border-radius: $default-border-radius;
}
.selected .price {
  color: #ffffff;
  background-color: #607d8b;
}
.select-container {
  position: relative;
  select {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    opacity: 0;
  }
}
</style>
